// Finances::BankTransaction.category enum
export const BANK_TRANSACTION_CATEGORIES = {
  ORDER_VIRTUAL_ACCOUNT_BCA         : 'order_virtual_account_bca',
  ORDER_VIRTUAL_ACCOUNT_NON_BCA     : 'order_virtual_account_non_bca',
  ORDER_CREDIT_CARD_BCA             : 'order_credit_card_bca',
  ORDER_CREDIT_CARD_BNI             : 'order_credit_card_bni',
  ORDER_CREDIT_CARD_BRI             : 'order_credit_card_bri',
  ORDER_CREDIT_CARD_MANDIRI         : 'order_credit_card_mandiri',
  ORDER_CREDIT_CARD_BCA_INSTALLMENT : 'order_credit_card_bca_installment',
  ORDER_CREDIT_CARD_BNI_INSTALLMENT : 'order_credit_card_bni_installment',
  ORDER_KREDIVO                     : 'order_kredivo',
  ORDER_GOPAY_QRIS                  : 'order_gopay_qris',
  ORDER_EDC_TRANSFER                : 'order_edc_transfer',
  ORDER_MANUAL_BANK_TRANSFER        : 'order_manual_bank_transfer',
  SHIPMENT_CHARGE                   : 'shipment_charge',
  PAYMENT_CHARGE                    : 'payment_charge',
  INBOUND_CHARGE                    : 'inbound_charge',
  ADMIN_FEE                         : 'admin_fee',
  REFUND                            : 'refund',
  UNKNOWN                           : 'unknown'
}

// Finances::BankTransaction.cash_flow enum
export const BANK_TRANSACTION_CASH_FLOWS = {
  CREDIT : 'credit',
  DEBIT  : 'debit'
}
